import { combineReducers } from "redux";
import {
  documentsWithSearchConstants
} from "../../actions/documentsWithSearch/index";
import {
  detailsDocumentConstants
} from "../../actions/detailsDocument/index";
import {
  quaterConstants
} from "../../actions/detailsDocument/quater";
import {
  notesConstants
} from "../../actions/detailsDocument/notes";
import {
  previewConstants
} from "../../actions/detailsDocument/preview";
import {
  renameDocumentsConstants
} from "../../actions/documents/renameDocuments";

function previewDetails(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState =
    typeof state === "undefined"
      ? {
        status: {
          error: false,
          started: false,
          ended: false,
          errorNote: false,
          startedNote: false,
          endedNote: false
        }
      }
      : state;
  switch (type) {
  case previewConstants.OPEN_PREVIEW_NEW_START:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_START:
    return {
      content: null,
      status: {
        error: false,
        started: true,
        ended: false,
        errorNote: false,
        startedNote: false,
        endedNote: false
      }
    };
  case previewConstants.OPEN_PREVIEW_NEW_SUCCESS:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_SUCCESS:
    return {
      content: payload,
      status: {
        error: false,
        started: false,
        ended: true,
        errorNote: false,
        startedNote: false,
        endedNote: false
      }
    };
  case previewConstants.OPEN_PREVIEW_NEW_ERROR:
    return {
      content: null,
      status: {
        error: true,
        started: false,
        ended: false,
        errorNote: false,
        startedNote: false,
        endedNote: false
      }
    };
  case previewConstants.OPEN_PREVIEW_NEW_CLEAR:
    return {
      content: null,
      status: {
        error: false,
        started: false,
        ended: false,
        errorNote: false,
        startedNote: false,
        endedNote: false
      }
    };
  case detailsDocumentConstants.CLEAR_DETAIL:
    return {
      status: {
        error: false,
        started: false,
        ended: false,
        errorNote: false,
        startedNote: false,
        endedNote: false
      }
    };
  default:
    return defaultState;
  }
}

function info(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState =
    typeof state === "undefined"
      ? {
        details: null,
        status: { error: false, started: false, ended: false }
      }
      : state;
  switch (type) {
  case detailsDocumentConstants.GET_DOCUMENTS_DETAILS_START:
  case documentsWithSearchConstants.GET_DOCUMENTS_WITH_SEARCH_START:
    return {
      details: null,
      status: { error: false, started: true, ended: false }
    };
  case detailsDocumentConstants.GET_DOCUMENTS_DETAILS_SUCCESS:
    return {
      details: payload,
      status: { error: false, started: false, ended: true }
    };
  case detailsDocumentConstants.GET_DOCUMENTS_DETAILS_ERROR:
    return {
      status: {
        error: true,
        errorCode: payload.code,
        started: false,
        ended: false
      }
    };
  case notesConstants.MODIFY_NOTE_NEW_SUCCESS:
    let copyDetail = state ? defaultState.details : null;
    if (copyDetail) {
      let modifiedNote = copyDetail.notes.find(el => {
        return el.id === payload.noteId;
      });
      modifiedNote.noteText = payload.noteText;
      modifiedNote.updatedOn = new Date();
      return {
        details: copyDetail,
        status: { error: false, started: false, ended: true }
      };
    } 
    return defaultState;
    
  case notesConstants.CREATE_NOTE_SUCCESS:
    let cloneDetail = state ? defaultState.details : null;
    if (cloneDetail) {
      cloneDetail.notes.push({
        id: payload.id,
        createdBy: payload.createdBy,
        createdOn: new Date(),
        updatedOn: payload.updatedOn,
        userName: payload.userName,
        noteText: payload.noteText,
        itemClassifier: payload.itemClassifier
      });
      return {
        details: cloneDetail,
        status: { error: false, started: false, ended: true }
      };
    } 
    return defaultState;
    
  case notesConstants.DELETE_NOTE_SUCCESS:
    let preDetail = defaultState.details;
    if (preDetail) {
      let newDetailNotes = preDetail.notes.filter(el => {
        return el.id !== payload.noteID;
      });
      preDetail.notes = newDetailNotes;
      return {
        details: preDetail,
        status: { error: false, started: false, ended: true }
      };
    } 
    return defaultState;
    
  case detailsDocumentConstants.SET_DOCUMENT_VISIBILITY_STUDIO_SUCCESS:
    return {
      details: {
        ...defaultState.details,
        visibleByStudioOnly: payload.isVisibleByStudioOnly
      },
      status: { error: false, started: false, ended: true }
    };
  case quaterConstants.SET_QUATER_SUCCESS:
    let details = defaultState.details;
    let quaters = [];
    details.quaters.map(item => {
      if (item.value === payload.quater) {
        quaters.push({ ...item, active: true });
      } else {
        quaters.push({ ...item, active: false });
      }
      return quaters;
    });
    return {
      details: { ...defaultState.details, quaters: quaters },
      status: { error: false, started: false, ended: true }
    };
  case detailsDocumentConstants.CLEAR_DETAIL:
    return {
      details: null,
      status: { error: false, started: false, ended: false }
    };
  default:
    return defaultState;
  }
}

function isDocRemoved(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined" ? { success: false, error: false } : state;
  switch (type) {
  case detailsDocumentConstants.REMOVE_DOCUMENTS_START:
    return { started: true, success: true, error: false };
  case detailsDocumentConstants.REMOVE_DOCUMENTS_SUCCESS:
    return { started: false, success: true, error: false };
  case detailsDocumentConstants.REMOVE_DOCUMENTS_ERROR:
    return { started: false, success: false, error: true };
  case documentsWithSearchConstants.CLEAR_TOTAL_COUNT:
  case detailsDocumentConstants.CLEAR_DETAIL:
    return { started: false, success: false, error: false };
  default:
    return defaultState;
  }
}

function renameDocument(state, { type, payload }) {
  let defaultState =
    typeof state === "undefined"
      ? {
        status: { error: false, started: false, ended: false }
      }
      : state;
  switch (type) {
  case renameDocumentsConstants.RENAME_DOCUMENT_START:
    return {
      status: { error: false, started: true, ended: false }
    };
  case renameDocumentsConstants.RENAME_DOCUMENT_SUCCESS:
    return {
      status: { error: false, started: false, ended: true }
    };
  case renameDocumentsConstants.RENAME_DOCUMENT_ERROR:
    return {
      status: {
        error: true,
        started: false,
        ended: false
      }
    };
  default:
    return defaultState;
  }
}

export const detailDocument = combineReducers({
  info,
  previewDetails,
  isDocRemoved,
  renameDocument
});

export default detailDocument;
